/**
 * What the briefing says about the GROUND itself, read off the map the mission will be flown on (ROUND7 §4).
 * The order is written from the parameters alone, but whether there is a wall to breach is the generator's
 * business - a band's line, a cover run, the compound's perimeter - so the briefing asks the generator. It is
 * pure and deterministic: the same parameters give the same map the aircraft will fly to.
 */

import { generateMission } from '../../../gen';
import { isBreached } from '../../../sim/breach';
import type { MissionParams } from '../../../sim/types';

export interface BriefingGround {
  /** There is at least one wall on the map: the order says what opens one and what does not. */
  walls: boolean;
}

/** One map per set of parameters: a briefing repaints when a card is bought, and the ground has not moved. */
const CACHE = new Map<string, BriefingGround>();
const CACHE_MAX = 16;

export function groundOf(params: MissionParams): BriefingGround {
  const key = JSON.stringify(params);
  const known = CACHE.get(key);
  if (known !== undefined) return known;
  const def = generateMission(params);
  const ground: BriefingGround = { walls: def.props.some((p) => isBreached(p.kind)) };
  if (CACHE.size >= CACHE_MAX) CACHE.clear();
  CACHE.set(key, ground);
  return ground;
}
